import * as angular from 'angular';
import { Decimal } from 'decimal.js';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { StorageOfferResource } from 'app/storage-offer/storage-offer.resource';

class PlaceStorageOfferBidComponentCtrl implements ng.IController {
    public offer: StorageOfferDto;
    public onSuccessfullyPlacedBid: Function;

    public offerBid: StorageOfferBidDto;
    public submitPending: boolean = false;
    private formDisabled: boolean = false;
    public placeBidForm;
    public minQuantitiesForDisabledForm: string[] = [];
    public maxQuantitiesForDisabledForm: string[] = [];
    public quantitiesForDisabledForm: string[] = [];
    public priceAmountsForDisabledForm: string[] = [];

    constructor(
        private readonly $filter: ng.IFilterService,
        private storageOfferResource: StorageOfferResource,
        private errorHandler: ErrorHandler,
        private $anchorScroll: ng.IAnchorScrollService
    ) {}

    $onInit(): void {
        this.initBidValues();
    }

    public createProductBid(productId: number): StorageProductBidDto {
        return (<StorageProductBidDto>{
            storageProductId: productId,
            minQuantityValue: 0,
            maxQuantityValue: 0,
            priceAmount: { value: '0', floatingPointNumber: true },
            storageContractType: null
        }) as StorageProductBidDto;
    }

    public modifyBid() {
        this.formDisabled = false;
    }

    public placeBid(form: ng.IFormController): boolean {
        if (!form.$valid) {
            return false;
        }

        if (!this.formDisabled) {
            this.offerBid.productBids.forEach((offerBid, index) => {
                offerBid.minQuantityValue = offerBid.minQuantityValue || 0;
                offerBid.maxQuantityValue = offerBid.maxQuantityValue || 0;
                offerBid.priceAmount = offerBid.priceAmount || {
                    value: '0',
                    floatingPointNumber: true
                };
                this.setDisabledValueForMinQuantity(index);
                this.setDisabledValueForMaxQuantity(index);
                this.setDisabledValueForPriceAmount(index);
            });
            this.formDisabled = true;
            this.goToPlaceBidSection();
            return false;
        }

        this.submitPending = true;

        this.offerBid.productBids.forEach((bid) => delete bid.quantityValue);

        this.storageOfferResource
            .placeBid(
                { id: this.offer.id },
                this.offerBid,
                (res: StorageOfferBidDto) => {
                    this.initBidValues();
                    this.placeBidForm.$setUntouched();
                    this.placeBidForm.$setPristine();
                    this.onSuccessfullyPlacedBid();
                },
                (err: any) => {
                    this.errorHandler(err);
                }
            )
            .$promise.finally(() => {
                this.submitPending = false;
                this.formDisabled = false;
            });

        return true;
    }

    public goToPlaceBidSection(): void {
        this.$anchorScroll('place-a-bid');
    }

    private initBidValues() {
        this.offerBid = { productBids: [] } as StorageOfferBidDto;
        this.offer.products.forEach((product) =>
            this.offerBid.productBids.push(this.createProductBid(product.id))
        );
        this.offerBid.productBids.forEach((bid) =>
            this.setValuesForDisabledForm(bid)
        );
    }

    private setValuesForDisabledForm(bid) {
        this.minQuantitiesForDisabledForm.push(
            this.$filter('number')(bid.minQuantityValue)
        );
        this.maxQuantitiesForDisabledForm.push(
            this.$filter('number')(bid.maxQuantityValue)
        );
        this.quantitiesForDisabledForm.push(
            this.$filter('number')(bid.quantityValue)
        );
        this.priceAmountsForDisabledForm.push(
            this.$filter('number')(
                '' + bid.priceAmount.value,
                this.getDecimalPlaces(bid.priceAmount.value)
            )
        );
    }

    private copySingleQuantityToMinMaxForTwoBiddingRounds(i: number) {
        this.offerBid.productBids[i].minQuantityValue = angular.copy(
            this.offerBid.productBids[i].quantityValue
        );
        this.offerBid.productBids[i].maxQuantityValue = angular.copy(
            this.offerBid.productBids[i].quantityValue
        );
    }

    public setDisabledValueForMinQuantity(i: number) {
        const minQuantityValue = this.offerBid.productBids[i].minQuantityValue;
        this.minQuantitiesForDisabledForm[i] =
            this.$filter('number')(minQuantityValue);
    }

    public setDisabledValueForMaxQuantity(i: number) {
        const maxQuantityValue = this.offerBid.productBids[i].maxQuantityValue;
        this.maxQuantitiesForDisabledForm[i] =
            this.$filter('number')(maxQuantityValue);
    }

    public setDisabledValueForQuantity(i: number) {
        const maxQuantityValue = this.offerBid.productBids[i].quantityValue;
        this.quantitiesForDisabledForm[i] =
            this.$filter('number')(maxQuantityValue);
    }

    public setDisabledValueForPriceAmount(i: number) {
        if (!this.offerBid.productBids[i].priceAmount) return;
        const priceAmount = this.offerBid.productBids[i].priceAmount.value;
        this.priceAmountsForDisabledForm[i] = this.$filter('number')(
            '' + priceAmount,
            this.getDecimalPlaces(priceAmount)
        );
    }

    public getDecimalPlaces(value: Decimal | string): number {
        if (value instanceof Decimal) {
            return value.decimalPlaces();
        } else {
            return new Decimal(value).decimalPlaces();
        }
    }
}

angular.module('app').component('pkpPlaceStorageOfferBid', {
    controller: PlaceStorageOfferBidComponentCtrl,
    template: require('app/storage-offer-bid/place-storage-offer-bid.component.html'),
    bindings: {
        offer: '<',
        onSuccessfullyPlacedBid: '&'
    }
});
